import React from 'react';
import * as R from 'ramda';

import {codeMapping} from '@/config';
import {LocaleLink} from '@/routes';
import {lookup} from '@/i18n';
import {useTranslation} from 'react-i18next';

const PlanItem = ({
  plan: {id, productName, policyStatusCode, productCategory, planNo},
}) => {
  const colorMap = codeMapping('plan_record_type_color');

  return (
    <tr>
      <td>
        <div
          className='smallProdSquarBullet'
          style={{backgroundColor: colorMap[productCategory]}}
        />
      </td>
      <td>{lookup('product_type', productCategory)}</td>
      <td>
        <LocaleLink to={`/b2c/plan_detail/${id}`}>{productName}</LocaleLink>
      </td>
      <td>{lookup('policy_status', policyStatusCode)}</td>
      <td>
        <LocaleLink to={`/b2c/plan_detail/${id}`}>{planNo}</LocaleLink>
      </td>
    </tr>
  );
};

const PlanList = ({plans, order, sort}) => {
  useTranslation('myPlan'); // trick the component to re-render if global language is changed

  const list = R.compose(
    R.map(plan => <PlanItem plan={plan} key={plan.id} />),
    R.sort((order === 'asc' ? R.ascend : R.descend)(R.prop(sort)))
  )(plans);

  return <>{list}</>;
};

const PlanItemRwd = ({plan: {id, productName, productCategory, planNo}}) => {
  // useTranslation('myPlan'); // no need because language selection under RWD layout
  const colorMap = codeMapping('plan_record_type_color');

  return (
    <li>
      <div
        className='smallProdSquarBullet'
        style={{backgroundColor: colorMap[productCategory]}}
      />
      <div>
        <LocaleLink to={`/b2c/plan_detail/${id}`}>
          {lookup('product_type', productCategory)}
          <br />
          <strong>{productName}</strong>
          <br />
          {planNo}
        </LocaleLink>
      </div>
    </li>
  );
};

const PlanListRwd = ({plans}) =>
  R.map(plan => <PlanItemRwd plan={plan} key={plan.id} />)(plans);

export {PlanList, PlanListRwd};
